/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/performance'
import 'firebase/analytics'

import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'

import 'sweetalert2/dist/sweetalert2.min.css'

import LoadingButton from '@/components/LoadingButton.vue'
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'
import Help from '@/components/Help.vue'
import ConstantsMixin from '@/mixins/Constants.js'

import { BootstrapVue } from 'bootstrap-vue'
import _config from '@/config.js'
import VueSidebarMenu from 'vue-sidebar-menu'
import FontPicker from 'font-picker-vue'
import VueHtml2Canvas from 'vue-html2canvas'

import Hotjar from 'vue-hotjar'

var config = _config[process.env.NODE_ENV || 'development']

Vue.use(VueHtml2Canvas)
Vue.use(FontPicker)
Vue.use(firestorePlugin)
Vue.use(BootstrapVue)
Vue.component('Loading', Loading)
Vue.component('Error', Error)
Vue.component('LoadingButton', LoadingButton)
Vue.component('Help', Help)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.mixin(ConstantsMixin)
Vue.use(VueSidebarMenu)

if (config.hotjar_id) {
  Vue.use(Hotjar, {id: config.hotjar_id})
}

import '@fortawesome/fontawesome-pro/css/all.css'
import '@fortawesome/fontawesome-pro/js/all.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import '@/assets/custom.scss'

Vue.config.productionTip = false

firebase.initializeApp(config.firebase_config)

export const _firebase = firebase
export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
export const functions = firebase.functions()
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp
export const FieldValue = firebase.firestore.FieldValue
export const perf = firebase.performance()
export const analytics = firebase.analytics()

if (process.env.NODE_ENV === 'local') {
  functions.useFunctionsEmulator('http://127.0.0.1:5000')
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
